import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { Tab } from '@headlessui/react';
import { BuildingOffice2Icon, Square2StackIcon, TruckIcon } from '@heroicons/react/24/outline';
import BusinessDetailsTab from './BusinessDetailsTab';
import VegetablesTab from './VegetablesTab';

export default function BusinessSettings() {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const tabs = [
    { name: 'Business Details', icon: BuildingOffice2Icon },
    { name: 'Vegetables', icon: Square2StackIcon },
  ];

  return (
    <div>
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">Settings</h1>
          <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">
            Manage your business details and vegetables
          </p>
        </div>
      </div>

      <div className="mt-8">
        <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
          <Tab.List className="flex flex-wrap gap-2">
            {tabs.map((tab) => (
              <Tab
                key={tab.name}
                className={({ selected }) => `
                  ${selected
                    ? 'bg-primary-600 text-white dark:bg-primary-500 dark:text-white'
                    : 'bg-white text-gray-600 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700'
                  } 
                  rounded-full px-4 py-2 text-sm font-medium border border-gray-300 dark:border-gray-700 
                  transition-colors duration-150 ease-in-out flex items-center space-x-2
                `}
              >
                <tab.icon className="h-5 w-5" />
                <span>{tab.name}</span>
              </Tab>
            ))}
          </Tab.List>

          <Tab.Panels className="mt-4">
            <Tab.Panel>
              <BusinessDetailsTab />
            </Tab.Panel>
            <Tab.Panel>
              <VegetablesTab />
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </div>
  );
}